import React, { useRef } from "react";
import "./ProfileImageUploader.css";

export default function ProfileImageUploader({ image, onChange }) {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    // Pass both file & local preview to the parent
    onChange({ file, previewUrl });
  };

  return (
    <div 
      className="profile-image-wrapper" 
      onClick={() => fileInputRef.current.click()}
    >
      <img src={image} alt="Profile" className="profile-photo editable" />
      <div className="upload-overlay">Change</div>

      <input
        type="file"
        ref={fileInputRef}
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
}
